import { useFormikContext } from 'formik';

import { GpusList } from '@/react/docker/host/SetupView/GpusList';

import { SwitchField } from '@@/form-components/SwitchField';
import { TextTip } from '@@/Tip/TextTip';
import { FormSection } from '@@/form-components/FormSection';

import { DockerSetupFormValues } from './types';

export function OtherSection() {
  const { values, setFieldValue } = useFormikContext<DockerSetupFormValues>();

  return (
    <FormSection title="Other">
      <div className="form-group">
        <div className="col-sm-12">
          <TextTip color="blue">
            Showing GPU in the UI is currently only available with Docker
            Standalone and is limited to NVIDIA graphics cards.
          </TextTip>
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.enableGpuManagement}
            onChange={(value) => setFieldValue('enableGpuManagement', value)}
            label="Show GPU in the UI"
            tooltip="This allows managing of GPUs for container/stack hardware acceleration via the Portainer UI. GPU support is currently limited to NVIDIA graphics cards only."
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-gpu-management-switch"
          />
        </div>

        {values.enableGpuManagement && (
          <div className="col-sm-12">
            <div className="pl-4">
              <GpusList
                value={values.gpus}
                onChange={(value) => setFieldValue('gpus', value)}
              />
            </div>
          </div>
        )}
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.enableImageNotification}
            onChange={(value) =>
              setFieldValue('enableImageNotification', value)
            }
            label="Show image up to date indicators for Stacks, Services and Containers"
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-image-notification-switch"
          />
        </div>
      </div>
    </FormSection>
  );
}
